module.exports = __webpack_public_path__ + "icon-167x167.png";